export default __webpack_public_path__ + "static/media/ico_project_white.635bcda3.svg";